@media screen {
    .outer-container {
        display: flex;
        flex-direction: column;
        min-height: 100vh;
        width: 100vw;
    }

    .inner-container {
        display: flex;
        flex: 1;
        width: 100%;
        max-height: 100vh;
        gap: 40px;
        padding: 40px;
        box-sizing: border-box;
    }

    .left-content {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        width: 50%;
    }

    .header {
        width: 100%;
    }

    .form {
        display: flex;
        flex-grow: 1;
        align-items: center;
    }

    .right-content {
        display: flex;
        flex-direction: column;
        width: 50%;
        padding-top: 80px;
        background-color: var(--blue-bg);
        border-radius: 16px;
        overflow: hidden;
        justify-content: space-between;
    }

    .right-top-section {
        display: flex;
        flex-direction: column;
        flex: 1;
        gap: 8px;
        justify-content: space-evenly;
    }

    .lead-board {
        z-index: 1;
    }

    .lead-board img {
        width: 100%;
        height: auto;
        max-height: 50vh;
        object-fit: contain;
    }

    .right-content .footer {
        margin-top: -64px;
        transform: translateY(12px);
        z-index: 0;
    }

    .left-content .title {
        display: none;
    }

    .left-content .footer {
        display: none;
    }
}

@media (max-height: 812px) {
    .inner-container {
        padding: 24px;
    }
}

@media (max-height: 736px) and (max-width: 1992px) {
    .inner-container {
        max-height: none;
        padding: 24px;
    }

    .header {
        padding-bottom: 16px;
    }
}

@media (max-width: 1192px) {
    .inner-container {
        max-height: none;
        padding: 24px;
    }

    .right-content {
        display: none;
    }

    .left-content {
        display: flex;
        flex-direction: column;
        width: 100%;
        height: auto;
        gap: 24px;
        justify-content: space-between;
    }

    .left-content .title {
        display: flex;
    }

    .left-content .footer {
        display: flex;
        width: calc(100% + 48px);
        margin: 0 -24px -24px -24px;
    }

    .header {
        padding-bottom: 16px;
    }

    .form {
        flex-grow: 0;
    }
}
